module.exports = __webpack_public_path__ + "static/media/3D.4e9c7455.svg";